var transitionFadeInFromLeft = function transitionFadeInFromLeft(options) {
  var transitionDelay = options.transitionDelay,
    transitionDuration = options.transitionDuration,
    transitionStatus = options.transitionStatus;
  switch (transitionStatus) {
    case 'entered':
      {
        return {
          opacity: 1,
          left: 0
        };
      }
    case 'entering':
      {
        return {
          opacity: 1,
          left: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, left ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms")
        };
      }
    case 'exited':
      {
        return {
          opacity: 0,
          left: '-100%'
        };
      }
    case 'exiting':
      {
        return {
          opacity: 0,
          transition: "opacity ".concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms, left ").concat(transitionDuration, "ms ease-in ").concat(transitionDelay, "ms"),
          left: '-100%'
        };
      }
    default:
      {
        // unmounted
        return {
          opacity: 0,
          left: '-100%'
        };
      }
  }
};
export { transitionFadeInFromLeft };